module.exports = __webpack_public_path__ + "img/29ne.1f9302fb.svg";